// @flow
import { nodelistToArray } from './helpers/nodelistToArray'
import { uuid } from './helpers/uuid'

// noinspection ES6ConvertVarToLetConst
declare var __HOT__: boolean

export function init (
  rootElementClassName: string,
  mountFn?: Function,
  callbackFn?: Function
) {
  const elements = findElements(rootElementClassName)
  elements.forEach(el => {
    el.id = uuid()
    window[rootElementClassName][el.id] = true

    if (mountFn) mountFn(el)

    if (__HOT__) {
      // Reload CSS file
      require('webpack/hot/emitter').on('webpackHotUpdate', currentHash => {
        document.querySelectorAll('link[href][rel=stylesheet]').forEach(link => {
          if (link instanceof HTMLLinkElement) {
            const nextStyleHref = link.href.replace(/(\?\d+)?$/, `?${Date.now()}`)
            link.href = nextStyleHref
          }
        })
      })
    }
  })
  if (callbackFn && elements && elements.length) callbackFn(elements)
}

export function findElements (rootElementClassName: string) {
  return nodelistToArray(document.getElementsByClassName(rootElementClassName)).filter(
    el => !isInitialized(el, rootElementClassName)
  )
}

export function isInitialized (el: HTMLElement, rootElementClassName: string) {
  return el.id && window[rootElementClassName][el.id]
}



// WEBPACK FOOTER //
// ./src/client/init.js